import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

export const StyledBadge = withStyles(() => ({
  badge: {
    right: -1,
    top: -6,
    // border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    width: 15,
    height: 19,
  },
}))(Badge);

// const useStyles = makeStyles((theme) => ({
export const styles = (theme) => ({
  imgLogo: {
    // marginTop: 10,
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
      // width: 100,
      // marginLeft: 'auto',
      // marginRight: 'auto',
      margin: '23px 0px 0px 20px',
    },
    [theme.breakpoints.down('sm')]: {
      width: 150,
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      width: 70,
      margin: '15px 0px 0px -5px',
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
  },
  boxMap: {
    position: 'absolute',
    zIndex: -1,
  },

  boxContentMobile: {
    right: 20,
    zIndex: 3,
    position: 'absolute',
    height: '100%',
    display: 'table',

    [theme.breakpoints.down('xs')]: {
      marginTop: 20,
    },
    [theme.breakpoints.between(600, 668)]: {
      zIndex: 4,
      paddingTop: 13,
      marginTop: 70,
      display: 'block',
      overflowX: 'scroll',
      minWidth: 55,
      marginBottom: 20,
      height: 250,
      right: 0,
    },
  },
  boxContentMoblieLandscape: {
    [theme.breakpoints.only(667)]: {
      zIndex: 4,
      paddingTop: 13,
      marginTop: 70,
      display: 'block',
      overflowX: 'scroll',
      minWidth: 55,
      marginBottom: 20,
      height: 300,
    },
  },
  boxMobile: {
    zIndex: 3,
    verticalAlign: 'middle',
    display: 'table-cell',
  },
  boxViewHeader: {
    right: 10,
    zIndex: 4,
    position: 'absolute',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      // left: 19,
    },
    [theme.breakpoints.down('xs')]: {
      right: 0,
      // marginTop: 7,
    },
  },

  boxViewSnackbar: {
    top: 100,
    zIndex: 3,
    position: 'absolute',
    display: 'table',
  },
  boxViewLeft: {
    left: 10,
    zIndex: 2,
    position: 'absolute',
  },
  boxViewRight: {
    right: 10,
    zIndex: 3,
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      left: 'auto',
    },
  },
  boxViewSub: {
    right: 10,
    zIndex: 3,
    position: 'absolute',
    marginTop: 170,
    width: 280,
  },
  // left
  boxViewHeadLeft: {
    left: 0,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 0,
    marginTop: '0%',
    width: 280,
  },
  boxViewRainfall: {
    left: 10,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 20,
    marginTop: '10%',
    width: 280,
  },
  boxViewWaterLevel: {
    left: 10,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 130,
    marginTop: '17%',
    width: 280,
  },
  boxViewDam: {
    left: 25,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 250,
    marginTop: '25%',
    width: 280,
  },
  boxViewQuality: {
    left: 60,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 380,
    marginTop: '32%',
    width: 280,
  },
  boxViewCrisis: {
    left: 100,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 500,
    marginTop: '40%',
    width: 280,
  },
  boxViewWarning: {
    left: 125,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 250,
    marginTop: '52%',
    width: 280,
  },

  // right
  boxViewHeadRight: {
    right: 250,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 0,
    marginTop: '0%',
    width: 335,
  },
  boxViewStorm: {
    right: 60,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 0,
    marginTop: '9%',
    width: 280,
  },
  boxViewForecastRainfall: {
    right: 10,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 80,
    marginTop: '14%',
    width: 280,
  },
  boxViewForecastWave: {
    right: 10,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 190,
    marginTop: '21%',
    width: 280,
  },
  boxViewRisk: {
    right: 50,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 300,
    marginTop: '27%',
    width: 300,
  },
  boxViewSalinity: {
    right: 130,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 410,
    marginTop: '34%',
    width: 280,
  },
  boxViewDronght: {
    right: 200,
    zIndex: 3,
    position: 'absolute',
    // marginTop: 510,
    marginTop: '40%',
    width: 280,
  },
  boxViewMobile: {
    backgroundColor: '#FFFFFF',
    borderRadius: '15px',
    border: '1px solid #999',
    padding: '10px',
    paddingTop: '10px',
  },
  shapeCircle: {
    backgroundColor: theme.palette.primary.main,
    width: 32,
    height: 32,
    borderRadius: '50%',
  },
  titleBox: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: theme.typography.fontKanit,
    color: '#000',
    whiteSpace: 'nowrap',
  },
  timeBox: {
    color: '#777',
    fontSize: 12,
    fontWeight: 500,
    fontFamily: theme.typography.fontKanit,
  },
  listsBox: {
    fontSize: 12,
    fontFamily: theme.typography.fontKanit,
    padding: theme.spacing((0.5), 2),
    borderRadius: 3,
  },
  contentBox: {
    fontSize: '0.7rem',
    fontFamily: theme.typography.fontKanit,
    width: 270,
    height: 66,
    padding: theme.spacing(2, 0),
    overflowY: 'scroll',
    marginBottom: theme.spacing(3),
  },

  positionBox: {
    left: 200,
  },

  // color
  darkRed: {
    color: 'white',
    textShadow: '1px 1px 3px #000',
    background: '#B02318',
  },
  red: {
    color: 'white',
    textShadow: '1px 1px 3px #000',
    background: '#ff0000',
  },
  yellow: {
    background: '#F89408',
  },
  orange: {
    background: '#FE8A04',
  },
  green: {
    background: '#46942E',
  },

  // modal
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5); !important',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    // boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  btn: {
    width: 5,
    height: 5,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  hiddenLine: {
    borderBottom: 'none',
  },
  pdpaPopupLink: {
    border: '1px solid #ccc',
    borderRadius: '50px',
    padding: '2px 10px',
    color: '#333',
    fontSize: '0.9em',
  },
});
